import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({
  selectedCount,
  labels,
  onStatusUpdate,
  onLabelAssign,
  onClearSelection
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const statusOptions = [
    { value: 'new', label: 'New' },
    { value: 'reviewed', label: 'Reviewed' },
    { value: 'archived', label: 'Archived' },
    { value: 'flagged', label: 'Flagged' }
  ];

  const labelOptions = labels?.map(l => ({ value: l?.id, label: l?.name }));

  const handleStatusChange = (status) => {
    setConfirmAction({ type: 'status', value: status });
    setShowConfirm(true);
  };

  const handleLabelAssign = (labelId) => {
    setConfirmAction({ type: 'label', value: labelId });
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    if (confirmAction?.type === 'status') {
      onStatusUpdate(confirmAction?.value);
    } else if (confirmAction?.type === 'label') {
      onLabelAssign(confirmAction?.value);
    }
    setShowConfirm(false);
    setConfirmAction(null);
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setConfirmAction(null);
  };

  return (
    <>
      <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="bg-primary text-primary-foreground rounded-full h-8 w-8 flex items-center justify-center text-sm font-semibold">
              {selectedCount}
            </div>
            <span className="text-sm font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? 'submission' : 'submissions'} selected
            </span>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <div className="w-full sm:w-48">
              <Select
                options={statusOptions}
                placeholder="Update status"
                onChange={handleStatusChange}
              />
            </div>

            <div className="w-full sm:w-48">
              <Select
                options={labelOptions}
                placeholder="Assign label"
                onChange={handleLabelAssign}
              />
            </div>

            <Button
              variant="outline"
              size="sm"
              iconName="X"
              onClick={onClearSelection}
            >
              Clear
            </Button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card border border-border rounded-lg max-w-md w-full p-6">
            <div className="flex items-start gap-4 mb-4">
              <div className="bg-warning/10 p-3 rounded-lg">
                <Icon name="AlertTriangle" size={24} className="text-warning" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  Confirm Bulk Action
                </h3>
                <p className="text-sm text-muted-foreground">
                  Are you sure you want to {confirmAction?.type === 'status' ? 'update the status' : 'assign labels'} for {selectedCount} {selectedCount === 1 ? 'submission' : 'submissions'}?
                </p>
              </div>
            </div>

            <div className="flex items-center justify-end gap-3">
              <Button
                variant="outline"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                variant="default"
                onClick={handleConfirm}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActionsBar;